import { useMemo } from 'react';
import { ROADSIDE_ASSISTANCE } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import { ROADSIDE_ASSISTANCE_PERMISSION } from '../constants/permissions';

const useHasAccessToRoadsideAssistance = () => {
  const hasRoadsideAssistanceCapabilities =
    useHasCapability(ROADSIDE_ASSISTANCE);
  const hasRoadsideAssistancePermission = useHasPermission(
    ROADSIDE_ASSISTANCE_PERMISSION,
  );
  const hasAccessToRoadsideAssistanceFeature = useMemo(() => {
    return (
      !!hasRoadsideAssistanceCapabilities?.hasCapability &&
      !!hasRoadsideAssistancePermission?.hasPermission
    );
  }, [hasRoadsideAssistanceCapabilities, hasRoadsideAssistancePermission]);

  return hasAccessToRoadsideAssistanceFeature;
};

export default useHasAccessToRoadsideAssistance;
